import { SUPPORT_LOCALES } from '@bit/utils'

import { LANGUAGE_LIST } from 'src/constant/LANGUAGE_LIST'
import { Router } from 'src/hook/biz/useRouter'
import { LocaleType } from 'src/util/locale'
import { localeToLanguageKey } from 'src/util/locale/localeToLanguageKey'

export interface ProcessUrlOptions {
  locale?: boolean
  query?: Record<string, string>
  host?: string
}

export const processUrl = (url: string, options?: ProcessUrlOptions): URL => {
  const urlWithHost = url.startsWith('http') ? url : `https://localhost${url}`

  const parsedUrl = new URL(urlWithHost)

  if (options?.host) {
    parsedUrl.host = options?.host
  }

  if (options?.locale) {
    const pathWithLocale = LANGUAGE_LIST.find((el) =>
      parsedUrl.pathname.startsWith(`/${el.locale}/`)
    )

    if (pathWithLocale) {
      parsedUrl.pathname = parsedUrl.pathname.replace(
        `/${pathWithLocale.locale}/`,
        `/${Router.locale}/`
      )
    } else {
      parsedUrl.pathname = `/${Router.locale}${parsedUrl.pathname}`
    }

    // 只有英文才需要带language 其他的语种在path处就会生效
    if (!pathWithLocale && Router.locale === SUPPORT_LOCALES.En) {
      parsedUrl.searchParams.set('language', localeToLanguageKey[Router.locale as LocaleType])
    }
  }

  if (options?.query) {
    Object.entries(options.query).forEach(([key, value]) => {
      parsedUrl.searchParams.set(key, value)
    })
  }

  return parsedUrl
}
